<template>
  <div class="commissions container">
    <h2> Costos y Comisiones de nuestros productos. </h2>
    <b> PRODUCTO </b>
    <p>FACTORAJE TRADICIONAL (CON RECURSO) <br>
      CRÉDITO SIMPLE <br>
      CRÉDITO A PROVEEDORES</p>
      <div class="horizontal-responsive">
       <table class="table-investment">
        <thead>
          <tr>
            <th>CONCEPTO</th>
            <th>MONTO O PORCENTAJE</th>
            <th>PERIODICIDAD</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>APERTURA</td>
            <td>$0.00</td>
            <td>ÚNICA</td>
          </tr>
          <tr>
            <td>GASTOS DE ORIGINACIÓN</td>
            <td>$2,600.00 MÁS IVA</td>
            <td>ANUAL</td>
          </tr>
          <tr>
            <td>COSTO CUMPLO FINANCIAMIENTO *</td>
            <td>1.3% IVA INCLUIDO</td>
            <td>MENSUAL POR OPERACIÓN, SOBRE MONTO FINANCIADO**</td>
          </tr>
          <tr>
            <td>COSTO CUMPLO ADMINISTRACIÓN Y COBRANZA *</td>
            <td>0.6% IVA INCLUIDO</td>
            <td>MENSUAL POR OPERACIÓN, SOBRE MONTO FINANCIADO**</td>
          </tr>
        </tbody>
      </table>
    </div>
    <b>PRODUCTO</b>
    <p>INVERSIÓN</p>
    <div class="horizontal-responsive">
      <table class="table-investment">
        <thead>
          <tr>
            <th>CONCEPTO</th>
            <th>MONTO O PORCENTAJE</th>
            <th>PERIODICIDAD</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>COSTO CUMPLO ADMINISTRACIÓN Y COBRANZA</td>
            <td>0.2% MÁS IVA</td>
            <td>MENSUAL POR CAPITAL INVERTIDO Y EFECTIVAMENTE COBRADO</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>* EL PORCENTAJE ESTABLECIDO PODRÁ DISMINUIR O NO COBRARSE EN BENEFICIO DEL SOLICITANTE Y DICHO BENEFICIO SE VERÁ REFLEJADO EN EL ANEXO CORRESPONDIENTE A DICHA OPERACIÓN.</p>
    <p>** SE CONTEMPLARÁ EL NÚMERO DE DÍAS EFECTIVAMENTE TRANSCURRIDOS POR MES CALENDARIO.</p>
  </div>
</template>

<script>
export default {
  name: 'Commissions'
}
</script>

<style lang="scss" scope>
  .commissions {
    h2{
      display: block;
      margin: 180px 0 40px;
      padding: 0;
      text-align: center;
      font-weight: 300;
    }
    .table-investment {
    td,
    th {
      font-size: .9em;
      line-height: 1.2;
    }
    th b {
      color: #999;
      }
    }
    margin-bottom: 70px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Commissions.vue